import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { articlePath, articleCat, formatRelativeDate, CATEGORY_LABEL } from "@/lib/readoo";
import { UpdatedBadge } from "@/components/NewsCard";

// Argomento del giorno: compare sopra il Primo Piano solo quando una notizia domina la giornata.
export function TopicOfDay({ topic }) {
  if (!topic?.lead) return null;
  const { lead, related = [] } = topic;
  return (
    <section data-testid="topic-of-day" className="rounded-2xl border-2 border-onSurface bg-surfaceSecondary overflow-hidden">
      <div className="flex flex-wrap items-center gap-x-3 gap-y-1 px-5 sm:px-7 py-3 bg-onSurface text-surface">
        <span className="relative flex w-2 h-2" aria-hidden="true">
          <span className="absolute inline-flex w-full h-full rounded-full bg-brand opacity-75 animate-ping" />
          <span className="relative inline-flex w-2 h-2 rounded-full bg-brand" />
        </span>
        <span className="font-mono text-[11px] uppercase tracking-[0.18em] text-surface/70 whitespace-nowrap">Argomento del giorno</span>
        <span data-testid="topic-of-day-label" className="basis-full sm:basis-auto font-serif text-xl font-semibold">{topic.label}</span>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-12">
        <Link to={articlePath(lead)} data-testid="topic-of-day-lead"
          className="group lg:col-span-7 p-5 sm:p-7 flex flex-col gap-3 border-b lg:border-b-0 lg:border-r border-hair">
          <span className="text-[11px] font-mono uppercase tracking-wider text-brand">{CATEGORY_LABEL[articleCat(lead)] || articleCat(lead)}</span>
          <h2 className="font-serif text-2xl sm:text-3xl font-semibold leading-tight text-onSurface group-hover:text-brand transition-colors">{lead.title}</h2>
          {lead.summary && <p className="text-sm sm:text-base text-subtle leading-relaxed line-clamp-3">{lead.summary}</p>}
          <div className="mt-auto flex items-center gap-2 pt-2 text-[11px] font-mono text-subtle">
            {lead.updates?.length > 0 && <UpdatedBadge id={`topic-${lead.article_id}`} />}
            <span>{formatRelativeDate(lead.published_at)}</span>
          </div>
        </Link>
        {related.length > 0 && <TopicRelated items={related} />}
      </div>
    </section>
  );
}

function TopicRelated({ items }) {
  return (
    <ol className="lg:col-span-5 divide-y divide-hair">
      {items.map((a, i) => (
        <li key={a.article_id}>
          <Link to={articlePath(a)} data-testid={`topic-of-day-related-${i}`}
            className="group flex items-start gap-3 px-5 sm:px-7 py-4 hover:bg-surfaceTertiary/40 transition-colors">
            <span className="flex-1 min-w-0">
              <span className="block font-serif text-[1.05rem] font-semibold leading-snug text-onSurface group-hover:text-brand transition-colors line-clamp-2">{a.title}</span>
              <span className="block mt-1 text-[11px] font-mono text-subtle">{formatRelativeDate(a.published_at)}</span>
            </span>
            <ArrowRight size={14} className="mt-1.5 shrink-0 text-brand transition-transform group-hover:translate-x-0.5" />
          </Link>
        </li>
      ))}
    </ol>
  );
}
